module.exports = __webpack_public_path__ + "img/1_4.bd04fa2d.png";